export enum CalendarType {
  GOOGLE = 'GOOGLE',
  YANDEX = 'YANDEX',
}
